export const cards = {
  primary: {
    display: 'flex',
    padding: '35px 40px',
    backgroundColor: 'bg.0',
    boxShadow: 3,
    mb: '5px',
  },
};
